import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';

const INITIAL_STATE = {
  filterDrawerOpen: false,
  loading: false,
  submitting: false,
  myData: [],
  myCount: 0,
  pendingData: [],
  approvedData: [],
  pendingCount: 0,
  approvedCount: 0,
  fromAccounts: [],
  toAccounts: [],
  paymentTypes: [],
  limits: {},
  activeSearch: '',
  activeFilters: {},
  activeTab: 'mine',
  approvalSubTab: 'pending',
  showCreateForm: false,
};

export const openFundTransferFilter = () => ({type: 'FT_FILTER_OPEN'});
export const closeFundTransferFilter = () => ({type: 'FT_FILTER_CLOSE'});
export const setFundTransferTab = (tab) => ({type: 'FT_SET_TAB', payload: tab});
export const toggleFundTransferCreateForm = () => ({
  type: 'FT_TOGGLE_CREATE_FORM',
});
export const hideFundTransferCreateForm = () => ({type: 'FT_HIDE_CREATE_FORM'});
export const setFundTransferSearch = (search) => ({
  type: 'FT_SET_SEARCH',
  payload: search,
});
export const setFundTransferFilters = (filters) => ({
  type: 'FT_SET_FILTERS',
  payload: filters,
});
export const setFundTransferApprovalSubTab = (subTab) => ({
  type: 'FT_SET_APPROVAL_SUBTAB',
  payload: subTab,
});

export const getFundTransferMine = (page = 1, search = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: 'FT_LOADING'});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/fund-transfer/me/?page=${page}${search}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: 'FT_MINE_SUCCESS', payload: data});
      } else {
        dispatch({type: 'FT_LOADING_DONE'});
      }
    } catch (err) {
      dispatch({type: 'FT_LOADING_DONE'});
    }
    return response;
  };
};

export const getFundTransferPending = (page = 1, search = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: 'FT_LOADING'});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/fund-transfer/?page=${page}${
          search.includes('&status=') ? '' : '&status=1'
        }${search}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: 'FT_PENDING_SUCCESS', payload: data});
      } else {
        dispatch({type: 'FT_LOADING_DONE'});
      }
    } catch (err) {
      dispatch({type: 'FT_LOADING_DONE'});
    }
    return response;
  };
};

export const getFundTransferApproved = (page = 1, search = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: 'FT_LOADING'});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/fund-transfer/?page=${page}${
          search.includes('&status=') ? '' : '&status=2,3,4,5,6'
        }${search}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: 'FT_APPROVED_SUCCESS', payload: data});
      } else {
        dispatch({type: 'FT_LOADING_DONE'});
      }
    } catch (err) {
      dispatch({type: 'FT_LOADING_DONE'});
    }
    return response;
  };
};

export const createFundTransfer = (formData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: 'FT_SUBMITTING'});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: 'finance/fund-transfer/',
        data: {
          from_account_id: formData.from_account,
          to_account_id: formData.to_account,
          amount: formData.amount,
          payment_type: formData.payment_type,
          remarks: formData.remarks,
        },
      });
    } catch (err) {}
    dispatch({type: 'FT_SUBMIT_DONE'});
    return response;
  };
};

export const approveFundTransfer = (id) => {
  return async () => {
    let response = {};
    try {
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: 'finance/fund-transfer/approve/',
        data: {record_ids: [id]},
      });
    } catch (err) {}
    return response;
  };
};

export const rejectFundTransfer = (id, remarks) => {
  return async () => {
    let response = {};
    try {
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: 'finance/fund-transfer/reject/',
        data: {record_ids: [id], remarks},
      });
    } catch (err) {}
    return response;
  };
};

export const getFundTransferAccounts = () => {
  return async (dispatch) => {
    let response = {};
    try {
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: 'finance/fund-transfer/accounts/',
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: 'FT_ACCOUNTS_SUCCESS', payload: data});
      }
    } catch (err) {}
    return response;
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action;
  switch (type) {
    case 'FT_FILTER_OPEN':
      return {...state, filterDrawerOpen: true};
    case 'FT_FILTER_CLOSE':
      return {...state, filterDrawerOpen: false};
    case 'FT_LOADING':
      return {...state, loading: true};
    case 'FT_LOADING_DONE':
      return {...state, loading: false};
    case 'FT_MINE_SUCCESS': {
      const {fund_transfers = {}, fund_transfer_ids = [], total = 0} =
        payload || {};
      const myRecords = fund_transfer_ids
        .map((id) => fund_transfers[id]?.basicInfo)
        .filter(Boolean);
      return {
        ...state,
        loading: false,
        myData: myRecords,
        myCount: total,
      };
    }
    case 'FT_PENDING_SUCCESS': {
      const {fund_transfers = {}, fund_transfer_ids = [], total = 0, summary} =
        payload || {};
      const pendingRecords = fund_transfer_ids
        .map((id) => fund_transfers[id]?.basicInfo)
        .filter(Boolean);
      return {
        ...state,
        loading: false,
        pendingData: pendingRecords,
        pendingCount: summary?.pending_count ?? total,
      };
    }
    case 'FT_APPROVED_SUCCESS': {
      const {fund_transfers = {}, fund_transfer_ids = [], total = 0} =
        payload || {};
      const approvedRecords = fund_transfer_ids
        .map((id) => fund_transfers[id]?.basicInfo)
        .filter(Boolean);
      return {
        ...state,
        loading: false,
        approvedData: approvedRecords,
        approvedCount: total,
      };
    }
    case 'FT_SUBMITTING':
      return {...state, submitting: true};
    case 'FT_SUBMIT_DONE':
      return {...state, submitting: false};
    case 'FT_ACCOUNTS_SUCCESS':
      return {
        ...state,
        fromAccounts: payload?.source_accounts || [],
        toAccounts: payload?.destination_accounts || [],
        paymentTypes: payload?.payment_types || [],
        limits: payload?.limits || {},
      };
    case 'FT_SET_SEARCH':
      return {...state, activeSearch: payload};
    case 'FT_SET_FILTERS':
      return {...state, activeFilters: payload};
    case 'FT_SET_APPROVAL_SUBTAB':
      return {...state, approvalSubTab: payload};
    case 'FT_SET_TAB':
      return {
        ...state,
        activeTab: payload,
        approvalSubTab: 'pending',
        showCreateForm: false,
        activeFilters: {},
        activeSearch: '',
      };
    case 'FT_TOGGLE_CREATE_FORM':
      return {...state, showCreateForm: !state.showCreateForm};
    case 'FT_HIDE_CREATE_FORM':
      return {...state, showCreateForm: false};
    default:
      return state;
  }
};
